
import React, { useEffect, useState, } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useFormik } from 'formik';
import { Button, TextField } from '@mui/material';
import { Errors } from '../../Component/ErrorShow';
import { gstSlabValidation } from '../../Validation/Validation';
import { useLocation, useNavigate, } from 'react-router-dom';
import Loading from '../../Component/Loading'
import { FaArrowLeft } from 'react-icons/fa';
import { EDIT_GST, INSERT_GST } from '../../Repository/GSTSlabRepo';
const AddEdit = () => {
    const [loading, setLoading] = useState(false)
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const gstId = params.get("gstId");
    const gstRate = parseFloat(params.get("gstRate"))
    console.log(gstRate, "gstRate")
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            gstRate: ""
        },
        validationSchema: gstSlabValidation,
        onSubmit: async (value) => {
            setLoading(true)
            let payload = {
                gstRate: value.gstRate,
                providerId: 1,
                gstId: gstId ? gstId : undefined
            }
            try {
                let response = gstId ? await EDIT_GST(payload) : await INSERT_GST(payload)
                toast.success(response.message)
                formik.resetForm()
                setTimeout(() => navigate("/layout/gst-slab"), 1000)
            } catch (error) {
                toast.error(error.message)
            }
            finally {
                setLoading(false)
            }

        }
    })

    useEffect(() => {
        if (gstId) {
            formik.setFieldValue("gstRate", gstRate)
        }
    }, [])

    return (
        <>
            {loading && <Loading />}
            <ToastContainer />
            <div className=' d-flex align-items-center'>
                <FaArrowLeft className='BACK_ICON' onClick={() => navigate("/layout/gst-slab")} />
                <h3 className='PAGE-NAME'>{gstId ? "Update" : "Add"}  GST Slab</h3>
            </div>
            <div className="container-fluid shadow">
                <form className="row g-3 mt-4" >
                    <div className="col-sm-6">
                        <label htmlFor="exampleInputEmail1" className='my-3'>GST Slab (%)<span className='Star_Mark'>*</span></label>
                        <TextField id="outlined-basic" variant="outlined" className='w-100' size='small'
                            type='number'
                            value={formik?.values?.gstRate}
                            onChange={(e) => formik.setFieldValue("gstRate", e.target.value)}
                            onInput={(e) => { if (e.target.value.length > 5) e.target.value = e.target.value.slice(0, 5); }}
                        />
                        <Errors formikfun={formik} name={"gstRate"} />
                    </div>
                    <div className="col-12 text-end">
                        <Button type="button" onClick={formik.handleSubmit} variant="contained" className='me-2 mui_button_color my-2' >save</Button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default AddEdit